// extracted by mini-css-extract-plugin
export default {"title":"ChatModalV2_title__9zw2I","spanId":"ChatModalV2_spanId__RK+gH","infoWrap":"ChatModalV2_infoWrap__Erh3Y"};